import { render, staticRenderFns } from "./BankDataIcon.vue?vue&type=template&id=ba6ffb2a&"
import script from "./BankDataIcon.vue?vue&type=script&lang=js&"
export * from "./BankDataIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports